import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().trim().required("Employee name is required."),
});

export { validationSchema };
